interface Item {
  title: string;
  href: string;
}

// 修改为一级导航结构 - 去掉Section接口和嵌套结构
// API文档导航结构
export const apiDocs: Item[] = [
  {
    title: 'Pricing',
    href: '/api-docs/pricing',
  },
  {
    title: 'Account',
    href: '/api-docs/account',
  },
  {
    title: 'Watermark Removal',
    href: '/api-docs/removal-watermark-api',
  },
];

// 从apiDocs中提取所有路由并创建配置
export const routeConfigs = apiDocs.reduce(
  (config, item) => {
    config[item.href] = {
      mobile: { footer: false },
      pc: { footer: false },
    };
    return config;
  },
  {} as Record<string, { mobile: { footer: false }; pc: { footer: false } }>
);
